import { render } from "./InterfaceSelect.vue?vue&type=template&id=0baf29e0&scoped=true"
import script from "./InterfaceSelect.vue?vue&type=script&lang=js"
export * from "./InterfaceSelect.vue?vue&type=script&lang=js"

import "./InterfaceSelect.vue?vue&type=style&index=0&id=0baf29e0&scoped=true&lang=scss"

import exportComponent from "/tmp/eb47f32b-990a-42a6-a461-0a5e6cce3094/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0baf29e0"]])

export default __exports__